// extracted by mini-css-extract-plugin
export var infoRow = "_pl-2";
export var labelContainer = "_pl-0";
export var rightInfo = "_pl-1";